import { Dispatch, SetStateAction, useCallback } from 'react';
import { Box, Flex, ScrollArea } from '@mantine/core';
import { Dropzone } from '@mantine/dropzone';
import { IconPhoto } from '@tabler/icons-react';
import { TFunction } from 'i18next';

import { Button, SectionLabel, Text } from 'components';
import { CreditService } from 'services';
import { AppUtils } from 'utils';
import AttachmentItem from './item';

interface INewDocumentation {
  cid: string;
  creditRequestId: number;
  deliveredAttachments: any[];
  isEditable: boolean;
  setDeliveredAttachments: Dispatch<SetStateAction<any[]>>;
  t: TFunction,
}

const NewDocumentation = ({
  cid,
  creditRequestId,
  deliveredAttachments,
  isEditable,
  setDeliveredAttachments,
  t,
}: INewDocumentation) => {

  const submitDocumentation = useCallback(() => {
    CreditService.uploadAttachments(cid, deliveredAttachments.filter(item => !item.id));
  }, [cid, deliveredAttachments]);

  const removeFile = useCallback((file: any) => {
    setDeliveredAttachments(old => old.filter(el => el !== file))
  }, []);

  return (
    <Box>
      <Box p={'md'}>
        <SectionLabel label={t('credit.documentation.delivered')} variant={'green'} pb={'sm'} />
        <ScrollArea
          type={'scroll'}
          overscrollBehavior={'contain'}
          mb={20}
        >
          {deliveredAttachments?.map((item, index) => (
            <AttachmentItem
              item={item}
              creditRequestId={creditRequestId}
              removeFile={removeFile}
              key={`selected-${index}`}
            />
          ))}
        </ScrollArea>
        {!isEditable && (
          <>
            <Dropzone
              onDrop={(files) => setDeliveredAttachments(old => ([...old, ...files]))}
              multiple={true}
              maxSize={10 * 1048576} // 10MB
              accept={['application/pdf', 'image/png', 'image/jpeg', 'image/jpg']}
              bd={'1px dashed gray'}
              p={20}
              mb={20}
              style={{ borderRadius: '10px' }}
            >
              <Flex direction='column' justify={'center'} align={'center'} gap={'sm'} style={{ pointerEvents: 'none' }}>
                <Dropzone.Idle>
                  <IconPhoto size={52} color='var(--mantine-color-dimmed)' stroke={1.5} />
                </Dropzone.Idle>
                <Box ta='center'>
                  <Text mb={20} size={'xl'}>{t('credit.documentation.new.description.1')}</Text>
                  <Text c='gray'>{t('credit.documentation.new.description.2')}</Text>
                </Box>
              </Flex>
            </Dropzone>
            <Button onClick={submitDocumentation} disabled={AppUtils.isEmpty(deliveredAttachments) || AppUtils.isEmpty(deliveredAttachments.filter(item => !item.id) || !isEditable)}>
              {t(`action.submitDocumentation`)}
            </Button>
            </>
          )
        }
      </Box>

    </Box>
  )
}

export default NewDocumentation;